module.exports = __webpack_public_path__ + "img/svg/step8.7afb3d84664f9f005dd40f2f7c36c915.svg";